import React from 'react'

function Layout({children}) {
  return (
    <div className="pb-[16px] px-[16px] pt-[8px] bg-[#f7f7f7] h-[100%] inputFormStyle overflow-auto" style={{height: 'calc(100vh - 56px)'}}>{children}</div>
  )
}

export default Layout